import React, { Component , useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import {authConfig} from '../auth/config';
import CardTipoVeiculo from './cardtipoveiculo';

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''



export const  TipoVeiculo= () => {
   
  const [state, setState] = useState([]);

   React.useEffect(() => {
    
   

    
            
       

    async function pegalista() {          
      
            
             var db = firebase.firestore();
             var query = await db.collection("tiposveiculo").get()
             .then(function(querySnapshot) {
        
              querySnapshot.forEach(function(doc) {
                var listausers=[];
                  listausers.push({id: doc.id, tipoveiculo: doc.data().tipoveiculo,
                    valorkmrodado:doc.data().valorkmrodado, categoriasmotorista:doc.data().categoriasmotorista, novo:false
                  });
                //console.log("veiculos pqp ", state );
               setState (currentArray => [...currentArray, listausers]);
               
     
              });
              
                      
            })
           .catch(error => {
               console.log('Não encontramos categorias cadastradas', error);
               alert("'Não encontramos categorias cadastrados'");
           });
           
           
     
           
         
    
      
    }
    pegalista();
      
  },[]); 

  
  const handlecadastar= ()=>{

       
    var listaveiculos1=[];
    listaveiculos1.push({id: false, TipoVeiculo: '',
      valorkmrodado:'', categoriamotoristas: '', novo:true});
  console.log("poxa valor q vai", listaveiculos1);
 setState (currentArray => [...currentArray,listaveiculos1]);
}

return(

<Container >
<CssBaseline />

<div id="cabeça" >
<Principal/>


</div>

<Typography className={classes.title} variant="h5" noWrap align="center">
Tipos de Veículo
</Typography>
<Container maxWidth="xs">
          <Grid container maxWidth="xs">
            <Grid item xs={6} >
  <Button
  onClick={handlecadastar}
  variant="contained"
    color="primary"
    className={classes.submit}
    >
    Cadastrar
  </Button>
</Grid>

</Grid>
</Container>
<div id="corpo"   align="center" className={classes.paper} >



<div id="corpoveiculo">
<Container maxWidth="xs">
<Grid container>
{console.log('tamanho da lista=> ', state)}
{state.map((item,id)=>(
  <Grid item key={id } xs={12} >

 <CardTipoVeiculo id={item.id} props={item}  />
 
 </Grid>
))}
</Grid>
</Container>
</div>


</div>


<Box mt={3}>
<Copyright/>
</Box>


</Container>
)

}


 
export default TipoVeiculo;

